<!--
# Module: 业务办理进度查询
-->
<template>
  <div class="manage-page">
    <div class="page-view">
      <div class="item-row" v-for="w in navMenu" :key="w.id" @click="opendialog(w.id)">
        <div class="name">
          <span>{{w.title}}</span>
        </div>
        <p class="tips">{{w.dec}}</p>
      </div>
    </div>
    <!-- 弹框 -->
    <div class="dialogform">
      <el-dialog
        v-if="dialog"
        :title="dialogtitle"
        :visible.sync="dialog"
        top="0"
        :width="dialigwidth"
        :before-close="handlecancel"
      >
        <!-- 表单 -->
        <el-form :inline="true" :model="formData" class="demo-form-inline" :rules="formDataRules">
          <el-form-item
            label="业务状态"
            prop="workstates"
            v-if="dialogname === 'Querypending_business'"
          >
            <el-select v-model="formData.workstates" clearable placeholder="请选择">
              <el-option
                v-for="item in WorkState_u"
                :key="item.value"
                :label="item.name"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="业务类型" prop="worktypes">
            <el-select v-model="formData.worktypes" clearable placeholder="请选择">
              <el-option
                v-for="item in WorkType"
                :key="item.value"
                :label="item.name"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSearch" size="small">查询</el-button>
          </el-form-item>
        </el-form>
        <el-divider />
        <!-- 表格 -->
        <el-table
          ref="tableDataref"
          :data="tableData"
          highlight-current-row
          :fit="false"
          stripe
          height="500"
          border
          size="mini"
        >
          <el-table-column
            align="center"
            :resizable="false"
            show-overflow-tooltip
            label="#"
            type="index"
            width="50"
          ></el-table-column>
          <el-table-column
            prop="user_code"
            align="center"
            :resizable="false"
            show-overflow-tooltip
            label="计划户编码"
            width="150"
          ></el-table-column>
          <el-table-column
            prop="user_name"
            align="center"
            :resizable="false"
            show-overflow-tooltip
            label="计划户名称"
            width="280"
          ></el-table-column>
          <el-table-column
            prop="work_type"
            align="center"
            :resizable="false"
            show-overflow-tooltip
            label="业务类型"
            width="150"
          >
            <template slot-scope="scope">
              <div v-for="(e, t) in WorkType" :key="t">
                <span v-if="scope.row.work_type === e.code">{{e.name}}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="work_status"
            align="center"
            :resizable="false"
            show-overflow-tooltip
            label="业务进度"
            width="120"
          >
            <template slot-scope="scope">
              <div v-for="(e, t) in WorkState" :key="t">
                <span v-if="scope.row.work_status === e.code">{{e.name}}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="create_time"
            align="center"
            :resizable="false"
            show-overflow-tooltip
            label="创建时间"
            width="180"
          ></el-table-column>
          <el-table-column
            prop="update_time"
            align="center"
            :resizable="false"
            show-overflow-tooltip
            label="更新时间"
            width="180"
          ></el-table-column>
          <el-table-column
            prop="expire_time"
            align="center"
            :resizable="false"
            show-overflow-tooltip
            label="截止办理时间"
            width="180"
          ></el-table-column>
          <el-table-column
            prop="is_overtime"
            align="center"
            :resizable="false"
            show-overflow-tooltip
            label="是否逾期未处理"
            width="150"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.is_overtime == 0">否</span>
              <span v-if="scope.row.is_overtime == 1">是</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="work_desc"
            align="center"
            :resizable="false"
            show-overflow-tooltip
            label="业务描述"
            width="200"
          ></el-table-column>
          <el-table-column label="操作" fixed="right" width="150" align="center">
            <template slot-scope="scope">
              <el-button
                size="small"
                class="btn-marleft"
                type="primary"
                plain
                @click.native.prevent="handlebtns(scope.row)"
              >处理</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-divider />
        <!-- 分页器 -->
        <el-pagination
          class="page"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="pageSize"
          :background="true"
          layout="total, prev, pager, next, jumper"
          hide-on-single-page
          :total="dataTotal"
        ></el-pagination>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  A_ADD_QueryDictListByCode, // 获取业务类型、状态数据集合
  A_ADD_WorkManageplan // 查询业务进度
} from '@/assets/js/axiosPresets'
export default {
  name: "businessQueryMessage",
  data () {
    return {
      dialogtitle: "", // 弹框标题
      dialogname: "", // 弹框名称（做区别）
      dialog: false, // 是否显示弹框
      dialigwidth: "1400px", // 弹框长度
      WorkType: [], // 业务类型数据集合
      WorkState: [], // 业务状态数据集合 
      WorkState_u: [], // 业务状态数据集合(未完成)
      formData: {
        worktypes: '', // 业务类型
        workstates: '' // 业务状态(必须)
      }, // 表单数据集合
      formDataRules: {
        workstates: [
          { required: true, message: "请选择业务状态", trigger: "change" }
        ]
      },
      tableData: [], // 表格数据集合
      curtableData: [], // 当前table 缓数据 
      currentPage: 1, // 当前页数
      dataTotal: 0, // 数据总条数
      pageData: [], // table分页数据 
      userInfo: null // 用户信息
    }
  },
  created () {
    this.$getoperationtype()
  },
  computed: {
    // 用户信息
    basicsUser () {
      return this.$store.state.userInfo
    },
    // 选项卡：菜单导航
    navMenu () {
      return [
        { id: 'Querypending_business', title: '查询业务列表', dec: '查询不同状态的业务列表' }
        // { id: 'Queryclosed_business', title: '查询已完结业务', dec: '查询计划户名下的水表信息' }
      ]
    },
    // 分页：单页数据量
    pageSize () {
      return 20
    }
  },
  watch: {
    // 监听用户信息
    basicsUser (v) {
      this.userInfo = this.$initUserInfo()
    },
    // 监听分页(解决初始页面数据)
    pageData (v) {
      this.handleCurrentPageData()
    }
  },
  mounted () {
    this.$init()
  },
  methods: {
    // 数据：获取业务类型、业务状态
    async $getoperationtype () {
      const wid = await A_ADD_QueryDictListByCode(["WorkProgressType", "WorkProgressState"])
      let _list = []
      wid.data.Content.filter(e => {
        switch (e.code) {
          case 'WorkProgressType':
            this.WorkType = e.dict_detail
            break
          case 'WorkProgressState':
            this.WorkState_u = e.dict_detail
            this.WorkState = e.dict_detail
            break
        }
      })
    },
    // 初始化：页面加载当前用户信息
    $init () {
      if (this.$store.state.ifrefresh) {
        this.userInfo = this.$store.state.userInfo
      }
    },
    // 初始化：获取基本信息(页面刷新加载)
    $initUserInfo () {
      if (this.$store.state.userInfo) {
        return this.$store.state.userInfo
      }
    },
    // 数据：获取业务进度
    async $get_workschedule (t, e) {
      const wid = await A_ADD_WorkManageplan({
        user_id: this.userInfo.oid,
        work_type: t || "",
        work_status: e || ""
      })
      let returnData = JSON.parse(JSON.parse(wid.data.d).resultMaps)
      returnData.filter(e => {
        e.user_code = this.userInfo.code
        e.user_name = this.userInfo.name
      })
      this.handleCreateDataPage(returnData)
      this.curtableData = returnData
      this.tableData = returnData
    },
    // 功能: 打开弹框,赋值
    opendialog (e) {
      switch (e) {
        case 'Querypending_business':
          this.$get_workschedule("", "1")
          this.formData.workstates = '1'
          this.dialogname = 'Querypending_business'
          this.dialogtitle = '查询未完结业务'
          break
        case 'Queryclosed_business':
          this.$get_workschedule("", "4")
          this.formData.workstates = '4'
          this.dialogname = 'Queryclosed_business'
          this.dialogtitle = '查询已完结业务'
          break
      }
      this.dialog = true
    },
    // 功能: 重置数据（取消）
    handlecancel () {
      this.dialog = false
      this.tableData = []
      this.curtableData = []
      this.formData = {
        worktypes: '', // 业务类型
        workstates: '' // 业务状态(必须)
      }
    },
    // 功能：筛选条件
    onSearch () {
      this.$get_workschedule(this.formData.worktypes, this.formData.workstates)
    },
    // 功能：筛选后的数据分页
    handleCreateDataPage (data) {
      let _pageData = []
      let _page = []
      let n = 0
      data.forEach(item => {
        _page.push(item)
        n++
        if (n % this.pageSize === 0 || n === data.length) {
          _pageData.push(_page)
          _page = []
        }
      })
      this.dataTotal = data.length
      this.pageData = _pageData
    },
    // 功能：设置当前分页数据
    handleCurrentPageData () {
      this.tableData = this.pageData[this.currentPage - 1]
    },
    // 功能：分页(当前页数)
    handleCurrentChange (val) {
      this.currentPage = Number(`${val}`)
      this.handleCurrentPageData()
    },
    // 功能：表格业务类型操作事件
    handlebtns (row) {
      let _path = ''
      switch (row.work_type) {
        case "201":
        case "202":
        case "203":
        case "205":
        case "206":
          _path = 'basicsManage'
          break
        case "301":
        case "302":
        case "303":
        case "304":
          _path = 'waterPlanManage'
          break
        case "204":
          _path = 'meterManage'
          break
        case "401":
        case "402":
          _path = 'overPlanManage'
          break
      }
      this.$router.push({ path: _path })
    }
  }
}
</script> 